<script setup>
import { ref, computed } from 'vue';
import { useManufacturersStore } from './stores/manufacturers';

const store = useManufacturersStore();
const cfg   = window.ebusManufacturers || {};
const i18n  = cfg.i18n || {};

const sortedSizeKeys = computed(() => {
    const labels = i18n.busSizes || {};
    return ['trolebus', 'midi', 'conventional', 'articulated'].sort((a, b) =>
        (labels[a] || a).localeCompare(labels[b] || b)
    );
});

const sortedCountries = computed(() =>
    [...store.uniqueCountries].sort((a, b) => a.name.localeCompare(b.name))
);

const countriesOpen = ref(false);

function setFilter(f) {
    store.setFilter(f);
    document.querySelector('.manufactors__grid')?.scrollIntoView({ behavior: 'smooth' });
}

function toggleCountries() {
    if (window.matchMedia('(max-width: 991px)').matches) {
        countriesOpen.value = !countriesOpen.value;
    }
}
</script>

<template>
  <div class="manufactors__filters">
    <p>{{ i18n.filters || 'Filtros' }}:</p>
    <p class="list__label">{{ i18n.busSizesLabel || 'Tamanhos do ônibus' }}:</p>
    <span
      :class="['filters__clean', { 'filters__clean--visible': store.activeFilter !== '*' }]"
      @click="store.clearFilter()"
    >x</span>
    <ul class="list">
      <li
        v-for="k in sortedSizeKeys"
        :key="k"
        :class="['filter', 'list__item', { 'list__item--active': store.activeFilter === `filter--${k}` }]"
        @click="setFilter(`filter--${k}`)"
      >
        <span :class="`bus-size bus-size--${k}`"></span>
        {{ (i18n.busSizes || {})[k] || k }}
      </li>
    </ul>
    <p
      :class="['filter', 'list__item', 'list__label',
               { 'list__item--active': store.activeFilter === 'filter--latin-america' }]"
      @click="setFilter('filter--latin-america')"
    >{{ i18n.operatingInLatinAmerica || '' }}</p>
    <p
      :class="['list__label', 'list__label--countries', 'list__label--mobile-collapsible',
               { 'list__label--mobile-collapsible--open': countriesOpen }]"
      @click="toggleCountries"
    >{{ i18n.manufacturersByCountry || '' }}:</p>
    <ul
      :class="['list', 'list--mobile--collapsible', 'list--countries',
               { 'list--open': countriesOpen }]"
    >
      <li
        v-for="c in sortedCountries"
        :key="c.slug"
        :class="['filter', 'list__item', { 'list__item--active': store.activeFilter === `filter--${c.slug}` }]"
        @click="setFilter(`filter--${c.slug}`)"
      >{{ c.name }}</li>
    </ul>
  </div>
</template>
